export const PRINT_TYPE_OPTIONS = {
  NO_PRICE: 'noPrice',
  SHOW_PRICE: 'showPrice'
}